'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames6 = require('classnames');

var _classnames7 = _interopRequireDefault(_classnames6);

var _uniqueId = require('lodash/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _Focusable = require('../common/Focusable');

var _ToggleSwitch = require('./ToggleSwitch.scss');

var _ToggleSwitch2 = _interopRequireDefault(_ToggleSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
  * Controlled switch
  */
var ToggleSwitch = function (_WixComponent) {
  _inherits(ToggleSwitch, _WixComponent);

  function ToggleSwitch(params) {
    _classCallCheck(this, ToggleSwitch);

    var _this = _possibleConstructorReturn(this, (ToggleSwitch.__proto__ || Object.getPrototypeOf(ToggleSwitch)).call(this, params));

    _this.id = (0, _uniqueId2.default)();
    return _this;
  }

  _createClass(ToggleSwitch, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          checked = _props.checked,
          _onChange = _props.onChange,
          size = _props.size,
          disabled = _props.disabled,
          colorUnchecked = _props.colorUnchecked,
          colorChecked = _props.colorChecked,
          colorDisabled = _props.colorDisabled;

      var id = this.id;
      var rootClassName = (0, _classnames7.default)(_ToggleSwitch2.default.toggleSwitch, (_classnames = {}, _defineProperty(_classnames, _ToggleSwitch2.default.toggleSwitchSmall, size === 'small'), _defineProperty(_classnames, _ToggleSwitch2.default.toggleSwitchXSmall, size === 'x-small'), _defineProperty(_classnames, _ToggleSwitch2.default.disabled, disabled), _classnames));

      var outerLabel = (0, _classnames7.default)(_ToggleSwitch2.default.outerLabel, _defineProperty({}, _ToggleSwitch2.default.disabled, disabled));

      var innerLabel = (0, _classnames7.default)(_ToggleSwitch2.default.innerLabel, _defineProperty({}, _ToggleSwitch2.default.disabled, disabled));

      var toggleActive = (0, _classnames7.default)(_ToggleSwitch2.default.toggleActive, _defineProperty({}, _ToggleSwitch2.default.disabled, disabled));

      var toggleInactive = (0, _classnames7.default)(_ToggleSwitch2.default.toggleInactive, _defineProperty({}, _ToggleSwitch2.default.disabled, disabled));

      var fillColor = function () {
        if (disabled) {
          return colorDisabled;
        } else if (checked) {
          return colorChecked;
        } else {
          return colorUnchecked;
        }
      }();

      return _react2.default.createElement(
        'div',
        _extends({
          className: rootClassName,
          onFocus: this.props.focusableOnFocus // For some reason eslint react/prop-types rule doesn't work here ?!#$
          , onBlur: this.props.focusableOnBlur
        }, (0, _Focusable.focusableStates)(this.props)),
        _react2.default.createElement('input', { type: 'checkbox', id: id, checked: checked, onChange: function onChange(e) {
            return !disabled && _onChange(e);
          }, disabled: disabled }),
        _react2.default.createElement(
          'label',
          { htmlFor: id, className: outerLabel, style: { background: fillColor }, tabIndex: disabled ? null : 0 },
          _react2.default.createElement(
            'label',
            { htmlFor: id, className: innerLabel },
            _react2.default.createElement(
              'svg',
              { className: toggleActive, viewBox: '0 0 41 32' },
              _react2.default.createElement('path', { style: { fill: fillColor }, d: 'M0.169 17.815c0.169 1.098 0.76 2.111 1.689 2.871l14.269 10.385c1.942 1.435 4.644 1.013 6.079-0.844l18.069-23.303c1.435-1.858 1.098-4.559-0.844-5.995s-4.644-1.098-6.164 0.844l-15.367 19.842-10.723-7.852c-1.942-1.435-4.644-1.013-6.164 0.844-0.76 0.929-1.013 2.111-0.844 3.208z' })
            ),
            _react2.default.createElement(
              'svg',
              { className: toggleInactive, viewBox: '0 0 143 32' },
              _react2.default.createElement('path', { style: { fill: fillColor }, d: 'M0 0h142.545v32h-142.545v-32z' })
            )
          )
        )
      );
    }
  }]);

  return ToggleSwitch;
}(_WixComponent3.default);

ToggleSwitch.displayName = 'ToggleSwitch';

ToggleSwitch.propTypes = {
  checked: _propTypes2.default.bool.isRequired,

  /** Callback function when user changes the value of the component  */
  onChange: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.bool,

  /** Specifies toggle size  */
  size: _propTypes2.default.oneOf(['x-small', 'small', 'large']),

  /** Color for unchecked toggle switch */
  colorUnchecked: _propTypes2.default.string,
  /** Color for checked toggle switch */
  colorChecked: _propTypes2.default.string,
  /** Color for disabled toggle switch */
  colorDisabled: _propTypes2.default.string
};

ToggleSwitch.defaultProps = {
  checked: false,
  onChange: function onChange() {},
  disabled: false,
  size: 'large'
};

exports.default = (0, _Focusable.withFocusable)(ToggleSwitch);